const initialState = {
  formTypes: []
}

export const formType = (state = initialState, action) => {
  switch (action.type) {
    case "GET_ALL_FORM_TYPE": {
      return { ...state, formTypes: action.formTypes }
    }
    case "CREATE_FORM_TYPE": {
      return { ...state, formTypes: action.formTypes }
    }
    default: {
      return state
    }
  }
}
